import { render, staticRenderFns } from "./EditTool.vue?vue&type=template&id=6facc07c&scoped=true"
import script from "./EditTool.vue?vue&type=script&lang=ts"
export * from "./EditTool.vue?vue&type=script&lang=ts"
import style0 from "./EditTool.vue?vue&type=style&index=0&id=6facc07c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facc07c",
  null
  
)

export default component.exports